import React, { useState } from 'react';
import { CustomDropdownMessage } from '../utilityComponents/customDropdown';

export default function Message({ message, messageIndexed }) {
  const [ show, setShow ] = useState("hidden");

  const { content, date, type, id } = message;
  let customClassName = `message-${type} message`;

  return (
    <article className="block-message">
      <div
        className={ customClassName }
        id={ `message-${id}` }
        onMouseEnter={() => setShow("visible")}
        onMouseLeave={() => setShow("hidden")}
      >
        {
          messageIndexed.msgIndexed !== null && (
            <div className="message-messageIndexed">
              <span>{ messageIndexed.author }</span>
              <span className="text-muted">
                {
                  messageIndexed.msgIndexed.content.length > 70 ? (
                    messageIndexed.msgIndexed.content.substr(0, 70) + "..."
                  ) : messageIndexed.msgIndexed.content
                }
              </span>
            </div>
          )
        }

        <div className="message-message">
          <div> { content } </div>
          <small className="text-muted">{ date }</small>

          <CustomDropdownMessage
            type={type}
            show={show}
            idMessage={id}
          >
            <i className="bi bi-chevron-down"></i>
          </CustomDropdownMessage>
        </div>
      </div>
    </article>
  );
}
